import axios from "axios";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState, useRef } from "react";
import ticno from "../../../../../images/team-member-tab/table-no.svg";
import ticyes from "../../../../../images/team-member-tab/table-yes.svg";
import editimgblue from "../../../../../images/team-member-tab/edit-btn-blue.svg";
import { setNotification } from "../../../../../features/notification/notificationSlice.js";
import { setProjectAdded } from "../../../../../features/projects/projectSlice.js";
import { useUpdateProjectCost, useUserProjectCost } from "../../../../../components/TimeTracker/TimeTrackerTeam/TimeTrackerTeamMembers/teamMemberApi.jsx";
import { isMvpEnv } from "../../../../../utils/brandLogo";
import MvpBillableRateModal from "../MvpBillableRateModal.jsx";

export default function ProjectCost(props) {
  const dispatch = useDispatch();
  const [cost, setCost] = useState(0);
  const billableRateEditRef = useRef(null);
  const [editableRow, setEditableRow] = useState(-1);
  const [rateOpen, setRateOpen] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const token = user.token;
  const [loading, setLoading] = useState(true);
  const [isUpdateLoading, setIsUpdateLoading] = useState(false);
  const updateBillableRateMutation = useUpdateProjectCost(token);
  const { projectAdded } = useSelector((state) => state.project);
  const notifyUpdate = useSelector((state) => state.notification.notificationState);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await axios.post(
          "/api/project-user-costs",
          { projectId: props.projectId, userId: props.item._id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setCost(response.data?.amount || 0);
      } catch (error) {
        console.error("Error fetching data:", error);
        setCost(0);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [props.item._id, props.projectId, projectAdded, notifyUpdate, token]);

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    if (!cost) {
      toast.error("Billable cost cannot be empty!", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      billableRateEditRef.current.focus();
      return;
    }

    try {
      setIsUpdateLoading(true);
      const response = await updateBillableRateMutation.mutateAsync({
        projectId: props.projectId,
        userId: props.item._id,
        amount: cost,
      });
      const data = response.data;

      if (data.status === "error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        toast.success("Billable rate updated successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setEditableRow(-1);
        dispatch(setNotification(Date.now()));
        dispatch(setProjectAdded());
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        return;
      }
      toast.error("Something went wrong", { position: "bottom-right", autoClose: 2000 });
    } finally {
      setIsUpdateLoading(false);
    }
  };

  const cancelChanges = () => {
    setEditableRow(-1);
  };

  const handleEdit = (item, index) => {
    if (isMvpEnv() && window.innerWidth <= 991) {
      setRateOpen(true);
      return;
    }
    setEditableRow(index);
  };

  const numberInputOnWheelPreventChange = (e) => {
    // Prevent the input value change
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  return (
    <>
      {isMvpEnv() && (
        <MvpBillableRateModal
          isOpen={rateOpen}
          onClose={() => setRateOpen(false)}
          item={props.item}
          projectId={props.projectId}
          clientCurrency={props.clientPreferredCurrency || "USD"}
          billableAmount={cost}
          canEditCost={props.canEditCost}
          onCostUpdated={props.onCostUpdated}
        />
      )}
      <style>
        {`
          @keyframes pulse {
            0%, 100% { opacity: 1; }
            50% { opacity: 0.5; }
          }
        `}
      </style>
      <div className="edit-value-changebtn-tic">
        {editableRow === props.item._id ? (
          <input
            type="number"
            value={cost}
            onChange={(e) => setCost(e.target.value)}
            ref={billableRateEditRef}
            onWheel={numberInputOnWheelPreventChange}
          />
        ) : (
          loading ? (
            <div
              style={{
                width: "80px",
                height: "18px",
                borderRadius: "4px",
                backgroundColor: "#e5e7eb",
                animation: "pulse 1.5s ease-in-out infinite",
              }}
            />
          ) : (
            `${cost ?
              new Intl.NumberFormat('en-US', { style: 'currency', currency: props.clientPreferredCurrency }).format(cost)
              :
              new Intl.NumberFormat('en-US', { style: 'currency', currency: props.clientPreferredCurrency }).format(0.00)
            }`
          )
        )}
        {editableRow === props.item._id ? (
          <>
            <div className="hello-boom-open">
              {isUpdateLoading ? (
                <>
                  <button
                    className="sep-pop-btn"
                    disabled
                    style={{
                      opacity: 0.6,
                      cursor: "not-allowed",
                    }}
                  >
                    <div
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "4px",
                        backgroundColor: "#e5e7eb",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  </button>
                  <button
                    className="sep-pop-btn"
                    disabled
                    style={{
                      opacity: 0.6,
                      cursor: "not-allowed",
                    }}
                  >
                    <div
                      style={{
                        width: "16px",
                        height: "16px",
                        borderRadius: "4px",
                        backgroundColor: "#e5e7eb",
                        animation: "pulse 1.5s ease-in-out infinite",
                      }}
                    />
                  </button>
                </>
              ) : (
                <>
                  <button className="sep-pop-btn" onClick={handleUpdateSubmit}>
                    <img src={ticyes} alt="yes" />
                  </button>
                  <button className="sep-pop-btn" onClick={() => cancelChanges()}>
                    <img src={ticno} alt="no" />
                  </button>
                </>
              )}
            </div>
          </>
        ) : (
          <button
            className="main-edit-btn-parent"
            onClick={() => handleEdit(props.item, props.item._id)}
            disabled={props.isProjectArchived}
            style={{ cursor: props.isProjectArchived ? "not-allowed" : "pointer", opacity: props.isProjectArchived ? 0.6 : 1 }}
          >
            <img src={editimgblue} alt="edit" />
            Edit
          </button>
        )}
      </div>
    </>
  );
}
